import { Injectable, computed, signal } from '@angular/core';
import { BOTTOM_NAV_ITEMS, DEFAULT_BASE_HEADER_OPTIONS, SIDE_NAV_ITEMS } from '@core/constants/layout.constant';
import { BaseHeaderOptions, HeaderOptions, LayoutConfig, NavigationConfig } from '@core/models/layout.model';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private _header = signal<HeaderOptions>(DEFAULT_BASE_HEADER_OPTIONS);
  private _showBottomNav = signal(true);

  readonly header = computed(() => this._header());
  readonly showBottomNav = computed(() => this._showBottomNav());

  readonly navigation = signal<NavigationConfig>({
    bottomNav: BOTTOM_NAV_ITEMS,
    sideNav: SIDE_NAV_ITEMS,
  });
  setHeader(options: HeaderOptions) {
    const mergeBaseOptions = (base: BaseHeaderOptions): Required<BaseHeaderOptions> => {
      return {
        ...DEFAULT_BASE_HEADER_OPTIONS,
        ...base,
      };
    };

    let mergedOptions: HeaderOptions;

    if ('breakpoints' in options && options.breakpoints) {
      mergedOptions = {
        breakpoints: {
          mobile: mergeBaseOptions(options.breakpoints.mobile || {}),
          desktop: mergeBaseOptions(options.breakpoints.desktop || {}),
        },
      };
    } else {
      mergedOptions = mergeBaseOptions(options as BaseHeaderOptions);
    }

    this._header.update(value => ({
      ...value,
      ...mergedOptions,
    }));
  }

  setBottomNavVisible(visible: boolean) {
    this._showBottomNav.set(visible);
  }

  applyLayout(config: Partial<LayoutConfig>) {
    if (config.header !== undefined) this.setHeader(config.header!);
    if (config.showBottomNav !== undefined) this.setBottomNavVisible(config.showBottomNav);
  }

  reset() {
    this._header.set(DEFAULT_BASE_HEADER_OPTIONS);
    this._showBottomNav.set(true);
  }
}
